/**
 * Models a Diagnosis Review Group.
 */

import Brace from "backbone.brace";
import { isValidDate, dateDifference } from "../../utils";

const Model = Brace.Model.extend({
  namedAttributes: {
    id: String,
    fromDateOfService: String,
    throughDateOfService: String,
    diagCode: String,
    mappedHCCs: String,
    claimNumber: String,
    commercialPlanId: String,
    actionApproveSubmission: Boolean,
    actionStartEvaluation: Boolean,
    note: String,
    // flags - set by API on POST response
    valid: Boolean,
    errors: [String],
    diagnosisAttributes: [Number],
    diagnosisAttributesDisplay: String,
  },

  defaults: {
    fromDateOfService: null,
    throughDateOfService: null,
    diagCode: null,
    mappedHCCs: null,
    claimNumber: null,
    commercialPlanId: null,
    actionApproveSubmission: null,
    actionStartEvaluation: null,
    note: null,
    valid: null,
    errors: null,
    diagnosisAttributes: null,
    diagnosisAttributesDisplay: null,
  },

  validate(attrs) {
    // from date cannot be empty
    if (!isValidDate(attrs.fromDateOfService)) {
      this.set("valid", false);
      return "Please enter a DOS From Date";
    }

    // thru date cannot be empty
    if (!isValidDate(attrs.throughDateOfService)) {
      this.set("valid", false);
      return "Please enter a DOS Through Date";
    }

    const dateDiff = dateDifference(
      attrs.throughDateOfService,
      attrs.fromDateOfService
    );
    if (dateDiff < 0) {
      this.set("valid", false);
      return "The DOS Through Date must be the same or after the From Date";
    }

    // diag code cannot be empty
    if (_.isEmpty(attrs.diagCode)) {
      this.set("valid", false);
      return "Please enter a Diagnosis Code";
    }

    // diag must be valid
    if (!attrs.isValidDiagCode) {
      this.set("valid", false);
      return "The diag code you entered is invalid";
    }

    // when the claim number is empty...
    if (_.isEmpty(attrs.claimNumber)) {
      // there cannot be a commercial Id
      if (!_.isEmpty(attrs.commercialPlanId)) {
        this.set("valid", false);
        return "Please remove the commercial plan Id or select a related claim number";
      }
    } else {
      // commercial plan Id is required
      if (_.isEmpty(attrs.commercialPlanId)) {
        this.set("valid", false);
        return "Please enter a commercial plan Id";
      }
    }

    // made it this far? the model is valid
    this.set("valid", true);
  },
});

export { Model as default };
